module.exports = __webpack_public_path__ + "img/floorplan_citationCJ2.164dbf50.png";